// removed by extract-text-webpack-plugin
module.exports = {"base":"_2VDLf","isLarge":"jGmPH","disabled":"_1BXDn","defaultText":"_16oL6","completeText":"ylm_S","submittingText":"_1ubdT","text":"Jp29F","defaultPos":"_2NIVz","completePos":"_3jLFU","submittingPos":"_2mgJg","submitting":"_1GAJB","icon":"_1P1w_","spin":"_2l0Li","loadFill":"CmAhY","complete":"_16QuH","loadComplete":"_3G46u","textActive":"E3YZm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SubmitButton/SubmitButton.scss
// module id = 1884
// module chunks = 0